import axios from 'axios';
import { useQuery } from 'react-query';

import { AnythingsTypeResponse, AnythingType } from 'src/types/anything';

type UseAnythingTypesParams = {
  limit?: number;
};
export function useAnythingTypes(params: UseAnythingTypesParams) {
  return useQuery<AnythingsTypeResponse, unknown, AnythingType[]>(
    ['anythings', 'types', params],
    () =>
      axios.get('/api/anythings/types', {
        params,
      }),
    {
      select: (data) => data.data,
    }
  );
}
